import moment from 'moment';

export const LOCALSTORAGE_PIN_KEY_PREFIX = 'permissionPin-';

export enum PERMISSIONS_TABLE_COLUMNS {
    STATUS = 'Status',
    NAME = 'Name',
    EMAIL = 'Email',
    DESCRIPTION = 'Description',
    START = 'Start',
    END = 'End',
    PINVIEW = 'PinView',
    PIN = 'Pin',
    ACTIONS = 'Actions'
}

export const PERMISSIONS_DEFAULT_SORT_COLUMN = PERMISSIONS_TABLE_COLUMNS.END;
export const PERMISSIONS_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const PERMISSIONS_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const PERMISSIONS_PAGE_DEFAULT_SIZE = 10;

export const PERMISSIONS_TABLE_HEADER = [
    PERMISSIONS_TABLE_COLUMNS.STATUS,
    PERMISSIONS_TABLE_COLUMNS.NAME,
    PERMISSIONS_TABLE_COLUMNS.EMAIL,
    PERMISSIONS_TABLE_COLUMNS.DESCRIPTION,
    PERMISSIONS_TABLE_COLUMNS.START,
    PERMISSIONS_TABLE_COLUMNS.END,
    PERMISSIONS_TABLE_COLUMNS.PIN,
    PERMISSIONS_TABLE_COLUMNS.ACTIONS,
];

export const PERMISSION_DEFAULT_NAME = '';
export const PERMISSION_DEFAULT_START = moment().startOf('day').toDate();
export const PERMISSION_DEFAULT_END = moment().startOf('day').add(7, 'days').toDate();
export const PERMISSION_DEFAULT_TIMEZONE = 'Europe/Rome';

export const EXECUTE_COMMAND_PIN_PERMISSION_EXPIRED_ERROR_CODE = 48;


export const CALENDAR_EVENT_TIME_FORMAT = { hour: '2-digit', minute: '2-digit', meridiem: false };
// eslint-disable-next-line max-len
export const PERMISSIONS_CALENDAR_HEADER_TOOLBAR = { left: 'prev,next,today', center: 'title', right: 'dayGridMonth,dayGridWeek,timeGridDay' };
